module.exports = __webpack_public_path__ + "img/blower2.c50342d2.svg";